import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import { initRefs, updateRefs, useCallbacks } from "@/composables/datasetPermissions";
import { getPermissions, getPermissionsUrl, setPermissions } from "./services";
import DatasetPermissionsForm from "@/components/Dataset/DatasetPermissionsForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryDatasetPermissions',
    props: {
        historyId: null
    },
    setup(__props) {
        const props = __props;
        const loading = ref(true);
        const { managePermissionsOptions, accessPermissionsOptions, managePermissions, accessPermissions, simplePermissions, checked, } = initRefs();
        const inputsUrl = computed(() => {
            return getPermissionsUrl(props.historyId);
        });
        const title = "Change default dataset permissions for history";
        const formConfig = computed(() => {
            return {
                title: title,
                url: inputsUrl.value,
                submitTitle: "Save Permissions",
                redirect: "/histories/list",
            };
        });
        async function change(value) {
            const managePermissionValue = managePermissions.value[0];
            let access = [];
            if (value) {
                access = [managePermissionValue];
            }
            const formValue = {
                DATASET_MANAGE_PERMISSIONS: [managePermissionValue],
                DATASET_ACCESS: access,
            };
            setPermissions(props.historyId, formValue).then(onSuccess).catch(onError);
        }
        async function init() {
            const { data } = await getPermissions(props.historyId);
            updateRefs(data.inputs, managePermissionsOptions, accessPermissionsOptions, managePermissions, accessPermissions);
            loading.value = false;
        }
        const { onSuccess, onError } = useCallbacks(init);
        return { __sfc: true, props, loading, managePermissionsOptions, accessPermissionsOptions, managePermissions, accessPermissions, simplePermissions, checked, inputsUrl, title, formConfig, change, init, onSuccess, onError, DatasetPermissionsForm };
    }
});
